export const optimizedProductFieldsString = `
  __typename
  id
  uid
  sku
  stock_status
  name
  new_from_date
  new_to_date
  manufacturer
  bestseller
  recommended
  main_category
  delivery_time

  stock_item {
    qty_increments
    min_sale_qty
    max_sale_qty
  }
  thumbnail {
    url
    position
    disabled
    label
  }
`;

export default `
  #graphql
  fragment OptimizedProductFields on ProductInterface {
    ${optimizedProductFieldsString}
    categories {
      id
      name
      level
      path
    }
  }
`;
